import { render, staticRenderFns } from "./PackagingTab.vue?vue&type=template&id=346389de"
import script from "./PackagingTab.vue?vue&type=script&lang=js"
export * from "./PackagingTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports